module.exports = __webpack_public_path__ + "img/heart-big.b153c577.svg";